export class CheckFileResponse {
  data: any
  messages: Array<any>
  resultCode: number
}

export class DataSuccess {
  size: string
}

export class DataFailure {
  percents: number
}
